// extracted by mini-css-extract-plugin
module.exports = {"sideIndicator":"CardButtons_sideIndicator__P75qp","reviewIndicator":"CardButtons_reviewIndicator__3eSnx","reviewIndicatorSaved":"CardButtons_reviewIndicatorSaved__3teUO"};